import Axios from 'axios'
import * as microsoftTeams from "@microsoft/teams-js"

export interface Dict {
  [key: string]: string
}

declare global {
  interface Window { teamAuthInterval: any }
}

export class PintraRedirect {
  private foundTeams = false;

  public constructor() {
    this.foundTeams = window.name && ['embedded-page-container', 'extension-tab-frame'].indexOf(window.name) >= 0
    const popupToggled = window.opener && localStorage.getItem('wpo365PopupToggled') == 'toggled'

    if (popupToggled) {

      if (this.foundTeams || !!localStorage.getItem('wpo365IsTeams')) {
        this.closeTeamsPopup()
      }
      else {
        localStorage.removeItem('wpo365PopupToggled')
        window.opener.location.reload()
        window.close()
      }
    }
  }

  public toMsOnline(loginHint: string = '', pRedirectTo: string = location.href): void {
    const siteUrlOverride = !!(window as any).wpo365.siteUrl
    const actionUrl = siteUrlOverride ? (window as any).wpo365.siteUrl : window.location.href
    const qs = this.queryString(window.location.href)
    const glue = Object.keys(this.queryString(actionUrl)).length === 0 ? '?' : '&'

    // Redirect from qs (e.g. dual login) overrides possible redirect passed as argument
    const redirectTo = 'redirect_to' in qs ? decodeURIComponent(qs['redirect_to']) : pRedirectTo

    // WordPress runs in an iframe (incl. Teams)
    if (window.parent != window) {
      console.debug('PintraRedirect.toMsOnline -> Setting popup toggled flag')
      localStorage.setItem('wpo365PopupToggled', 'toggled')
      const url = `${actionUrl}${glue}action=openidredirect&redirect_to=${redirectTo}&cb=${this.uuidv4()}`

      if (this.foundTeams) {
        // This is a reminder because the Teams authentication popup is more difficult to detect
        localStorage.setItem('wpo365IsTeams', 'yes')
        this.teamsPopup(url)
      }
      else {
        this.PopupCenter(url, 'msOnline')
      }

      return
    }

    // Not in an iframe
    const form = document.createElement('form')
    form.method = 'POST'
    form.action = `${actionUrl}${glue}cb=${this.uuidv4()}`
    const params: any = {
      action: 'openidredirect',
      login_hint: loginHint,
      redirect_to: redirectTo
    }
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        const hiddenField = document.createElement('input')
        hiddenField.type = 'hidden'
        hiddenField.name = key
        hiddenField.value = params[key]
        form.appendChild(hiddenField)
      }
    }
    document.getElementById('wpo365OpenIdRedirect').appendChild(form)
    form.submit()
  }

  private uuidv4 = (): string => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (Math.random() * 16) | 0,
        v = c == 'x' ? r : (r & 0x3) | 0x8
      return v.toString(16)
    })
  };

  private queryString = (url: string): Dict => {
    const qsStart = url.indexOf('?')
    if (qsStart == -1) {
      return {}
    }
    const qs = url.substr(qsStart + 1)
    const kvPairs = qs.split('&')
    const result: Dict = {}
    for (let i = 0; i < kvPairs.length; i++) {
      const kv = kvPairs[i].split('=')
      result[kv[0]] = kv.length == 2 ? kv[1] : ''
    }
    return result
  };

  private PopupCenter = (url: string, title: string, w: number = 600, h: number = 535) => {
    const width = screen.availWidth
    const height = screen.availHeight

    if (w > width) w = width
    if (h > height) h = height

    const left = (width - w) / 2
    const top = (height - h) / 2
    const newWindow = window.open(
      url,
      title,
      'width=' +
      w +
      ',height=' +
      h +
      ',top=' +
      top +
      ',left=' +
      left +
      'toolbar=no,menubar=no,scrollbars=no,location=no,status=no'
    )

    // Puts focus on the newWindow
    if (newWindow && window.focus) newWindow.focus()
  };

  private teamsPopup = (url: string) => {
    const placeholder = document.getElementById('wpo365OpenIdRedirect')
    const button = document.createElement('button')
    button.setAttribute('style', 'border: 1px solid #8c8c8c; background: #ffffff;')
    button.className = 'pintraRedirectMsSignin'
    button.innerHTML = `<div style="display: flex; height: 41px; box-sizing: border-box; pointer: cursor;"><img src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMSIgaGVpZ2h0PSIyMSIgdmlld0JveD0iMCAwIDIxIDIxIj48dGl0bGU+TVMtU3ltYm9sTG9ja3VwPC90aXRsZT48cmVjdCB4PSIxIiB5PSIxIiB3aWR0aD0iOSIgaGVpZ2h0PSI5IiBmaWxsPSIjZjI1MDIyIi8+PHJlY3QgeD0iMSIgeT0iMTEiIHdpZHRoPSI5IiBoZWlnaHQ9IjkiIGZpbGw9IiMwMGE0ZWYiLz48cmVjdCB4PSIxMSIgeT0iMSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgZmlsbD0iIzdmYmEwMCIvPjxyZWN0IHg9IjExIiB5PSIxMSIgd2lkdGg9IjkiIGhlaWdodD0iOSIgZmlsbD0iI2ZmYjkwMCIvPjwvc3ZnPg=="><span style="margin-left: 15px; padding-right: 12px; font-weight: 600; font-size: 15px; line-height: 41px; color: #5e5e5e;">Sign in with Microsoft</span>`
    button.onclick = () => {
      microsoftTeams.initialize(() => {
        microsoftTeams.authentication.authenticate({
          url: url,
          width: 600,
          height: 535,
          successCallback: function (result: any) { },
          failureCallback: function (reason: any) { },
        })
      })
    }
    placeholder.appendChild(button)
    window.teamAuthInterval = setInterval(() => {
      if (!localStorage.getItem('wpo365PopupToggled')) {
        console.debug('PintraRedirect.teamsPopup -> waiting for the popup to close')
        clearInterval(window.teamAuthInterval)
        window.location.reload()
      }
    }, 500)
  }

  private closeTeamsPopup = (): void => {
    microsoftTeams.initialize(() => {
      console.debug('PintraRedirect.closeTeamsPopup -> Teams SDK initialized')
      microsoftTeams.getContext(ctx => {
        localStorage.removeItem('wpo365PopupToggled')
        localStorage.removeItem('wpo365IsTeams')
        microsoftTeams.authentication.notifySuccess()
      })
    })
  }
}
